import { useMutation, useQueryClient } from "react-query";
import { api } from "utils/api";
import type { GalleryItemFormFields, GalleryItem } from "../types";
import { galleryKeys } from "./queryKeys";

type UpdateParams = GalleryItemFormFields & {
  artistId?: string;
  id?: string;
};

/**
 * API to update a portfolio item
 */
const updateGalleryItem = ({ artistId, id, ...formData }: UpdateParams) =>
  api.put<GalleryItem>(`/gallery/artists/${artistId}/${id}`, {
    body: JSON.stringify(formData),
  });

/**
 * Custom hook to update a portfolio item
 */
const useGalleryItemUpdate = (artistId?: string, id?: string) => {
  const queryClient = useQueryClient();
  return useMutation(
    (formData: GalleryItemFormFields) =>
      updateGalleryItem({ artistId, id, ...formData }),
    {
      onSuccess: (resp) => {
        queryClient.invalidateQueries(galleryKeys.lists());

        // Update the cache with new data
        queryClient.setQueryData(
          galleryKeys.detail("artist", artistId, id),
          resp
        );
      },
    }
  );
};

export { useGalleryItemUpdate };
